export default {
  // 获取下载中心列表
  GET_LIST: '/jcnapi/downloadArea/getList',
  DEL: '/jcnapi/downloadArea/delete',
  //保存
  SAVE: '/jcnapi/downloadArea/save',
  GET: '/jcnapi/downloadArea/getBanner',
  SET_BANNER: '/jcnapi/downloadArea/setBanner',
  GET_INFO: '/jcnapi/downloadArea/getInfo'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/download/index.js